import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { formatTimeForLastMessage, getConversationLastMessage, getConversationPartner } from './ConversationUtilities';

const ConversationsSidebar = ({ onSelectConversation, conversations, currentUser, isSidebarOpen, toggleSidebar, activeConversationId }) => {
  return (
    <div className={`chat-sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
      <div className="chat-sidebar-header-container">
        <button className="toggle-sidebar-button" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={isSidebarOpen ? faChevronLeft : faChevronRight} />
        </button>
        <div className="chat-sidebar-header">
          <h3>Chats</h3>
        </div>
      </div>
      <ul className="conversation-items">
        {Array.isArray(conversations) && conversations.length > 0 ? (
          conversations.map(conversation => (
            <li 
              key={conversation.id} 
              className={`conversation-item ${conversation.id === activeConversationId ? 'active' : ''}`} 
              onClick={() => onSelectConversation(conversation.id)}
            >
              <img 
                src={getConversationPartner(conversation, currentUser).profileImage} 
                alt="Profile" 
                className="profile-pic" 
              />
            <div className="sidebar-conversation-info">
              <div className="sidebar-conversation-header">
                <p className="sidebar-conversation-partner">
                  {getConversationPartner(conversation, currentUser).name}
                </p>
                <span className="sidebar-message-timestamp">
                  {conversation.messages?.length > 0
                    ? formatTimeForLastMessage(conversation.messages[conversation.messages.length - 1].timestamp)
                    : ''}
                </span>
              </div>
              <p className="sidebar-last-message">{getConversationLastMessage(conversation)}</p>
            </div>
            </li>
          ))
        ) : (
          <p>No conversations available</p>
        )}
      </ul>
    </div>
  );
};

export default ConversationsSidebar;